import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NoteViewModel } from '@/app/proxy/proxies';
import mapboxgl from 'mapbox-gl';
import { SharedModule } from '@/app/shared/shared.module';
import { CropHealthNoteItemComponent } from '../crop-health-note-item/crop-health-note-item.component';

@Component({
  selector: 'app-crop-health-note-view',
  imports: [SharedModule, CropHealthNoteItemComponent],
  templateUrl: './crop-health-note-view.component.html',
  styleUrl: './crop-health-note-view.component.less',
})
export class CropHealthNoteViewComponent implements OnInit, OnChanges {
  @Input() note: NoteViewModel;
  @Input() mapInstance: mapboxgl.Map;

  @Output() back = new EventEmitter();
  @Output() getAllNotes = new EventEmitter();

  marker: mapboxgl.Marker;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mapInstance'] && this.mapInstance && this.note?.coordinate) {
      this.addMarker();

      // disable zoom
      this.mapInstance.scrollZoom.disable();
      this.mapInstance.doubleClickZoom.disable();
      this.mapInstance.touchZoomRotate.disable(); // disables both zoom and rotate on touch
      this.mapInstance.boxZoom.disable(); // disables zoom using shift + drag
    }
  }

  ngOnInit(): void {}

  addMarker(): void {
    this.marker?.remove();
    // this.popup?.remove();
    const el = document.createElement('div');
    el.style.backgroundImage = `url('assets/svg/note-pin.svg')`;
    el.style.width = `50px`;
    el.style.height = `50px`;
    el.style.backgroundSize = '100%';

    const { lat, lng } = { lat: this.note.coordinate.latitude, lng: this.note.coordinate.longitude };

    if (!isNaN(lng) && !isNaN(lat)) {
      this.marker = new mapboxgl.Marker(el, { offset: [25, 30] }).setLngLat([lng, lat]).addTo(this.mapInstance!);
    }
  }

  onBackBtn() {
    this.marker?.remove();
    this.back.emit();

    // enable zoom
    this.mapInstance.scrollZoom.enable();
    this.mapInstance.doubleClickZoom.enable();
    this.mapInstance.touchZoomRotate.enable(); // enables both zoom and rotate on touch
    this.mapInstance.boxZoom.disable(); // disables zoom using shift + drag
  }
}
